
export interface ClientReferrerInformation {
    referrer?: string | undefined
    referralCode?: string | undefined
}

export class MarketingReferralConstants {
    static readonly marketingReferralCodeURLVariable = 'referralCode'
    static readonly maxReferralCodeLength = 20
    static readonly maxReferrerLength = 150

    static isReferrerInformationEmpty(referrerInformation: ClientReferrerInformation): boolean {
        if(referrerInformation.referrer != undefined) return false
        if(referrerInformation.referralCode != undefined) return false

        return true
    }
}
